import { ReferenceManyField, Datagrid, TextField, DateField, FunctionField } from 'react-admin';
import { DATETIME_FORMAT } from '../../utils';
import { ChipList } from '../common';

export const TagPrintingsList = () => (
  <ReferenceManyField
    reference="printings"
    target="tagId"
    label=""
    sort={{ field: 'startTime', order: 'DESC' }}
  >
    <Datagrid rowClick="show" bulkActionButtons={false}>
      <TextField source="id" label="ID" />
      <TextField source="uuid" label="UUID" />
      <TextField source="orderId" label="Order" />
      <FunctionField
        label="Machine"
        render={(record: { machine?: { id: number; serial: string } }) =>
          record.machine ? (
            <ChipList
              items={[
                {
                  id: record.machine.id,
                  label: record.machine.serial,
                  to: `/machines/${record.machine.id}/show`,
                },
              ]}
            />
          ) : null
        }
      />
      <DateField source="startTime" showTime options={DATETIME_FORMAT} />
      <DateField source="endTime" showTime options={DATETIME_FORMAT} />
      <FunctionField
        label="Meters Used"
        render={(record: { PrintingTag?: { meters: number } }) =>
          record.PrintingTag ? `${Number(record.PrintingTag.meters).toFixed(2)} m` : 'N/A'
        }
      />
    </Datagrid>
  </ReferenceManyField>
);
